/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  var windowWidth = $(window).width(),
    isSmallDevice = windowWidth < 800 ? true : false,
    isMobileDevice = windowWidth < 481 ? true : false;

  $(document).ready(function () {
    SetupNavDrawerMobile();
    // BR_Custom Top bar mobile dismiss
    SetupTopBarMobileDismiss();
    $(".menu__item.parent > a").each(function () {
      SetupNavMenuDesktop($(this));
    });

    $(document).on("click", ".modal--is-visible .drawer__overlay", function () {
      CloseOpenedNavMenu();
    });

    SetupSearchToggle();
    setTimeout(function () {
      SetupVariantSelector();
    }, 20);
    SetupCartItemNumberTracking();
    // BR_Custom Gift Wrap Item
    SetupGiftWrapItems();
    // BR_Custom Siblings colors product card
    SetupSiblingColorPreview();
    // BR_Custom Direct tap navigation (bypass WebKit double-tap on hover cards)
    SetupDirectTapNavigation();
    // BR_Custom Moving Media
    SetupMovingMedia();

    if (isSmallDevice) {
      HandleQuickBuyOnTouch();
    }

    if (
      $("body").hasClass("template-blog") ||
      $("body").hasClass("template-article")
    ) {
      SetupBlogMenu();
    }
    if (
      $("body").attr("id") == "production" ||
      $("body").attr("id") == "production-mobile"
    ) {
      RedirectToCorrepondingMobilePage();
      SetupProductionPageElements();
    }
    if ($("body#baserange-contact").length) {
      SetupContactForm();
    }
    if ($("body").attr("id") == "collections") {
      window.location.href = "/collections/new-arrivals";
    }

    //External Resources
    SetupShogunTrigger();
  });

  function SetupNavMenuDesktop($navItem) {
    $navItem.click(function (event) {
      event.preventDefault();
      //Hide other open menu if they are open
      $menuActive = $(this)
        .parent()
        .parent()
        .siblings(".menu__items")
        .first()
        .find(".is-visible");
      if ($menuActive.length) {
        $menuActive.toggleClass("is-visible");
      }
      //Hide/Show current menu
      $(this).parent().toggleClass("is-visible");

      //Hide/Show an overlay to the website
      if ($(".menu__items .is-visible").length) {
        if (!$("body.modal--is-visible").length) {
          $("body").addClass("modal--is-visible");
        }
      } else {
        $("body.modal--is-visible").removeClass("modal--is-visible");
      }
    });
  }
  function CloseOpenedNavMenu() {
    $(".menu__item.is-visible").removeClass("is-visible");
    $("body.modal--is-visible").removeClass("modal--is-visible");
  }

  function SetupNavDrawerMobile() {
    //Open drawer
    $(".js-drawer-open-custom").click(function () {
      $("body").addClass("js-drawer-open");
      $("#NavDrawerCustom").addClass("is-open");
    });
    $(".js-drawer-open-bis").click(function () {
      $("body").addClass("js-drawer-open");
      $("#NavDrawerBis").addClass("is-open");
    });
    //Close drawer
    $(".drawer__close").click(function () {
      $(this).closest(".is-open").removeClass("is-open");
      $("body").removeClass("js-drawer-open");
    });
    if ($("#NavDrawerCustom .mobile-nav__toggle").length) {
      $("#NavDrawerCustom .mobile-nav__has-sublist").each(function () {
        $(this).click(function (e) {
          e.preventDefault();
          if ($(this).hasClass("mobile-nav--expanded")) {
            $(this).removeClass("mobile-nav--expanded");
          } else {
            if ($("#NavDrawerCustom .mobile-nav--expanded").length) {
              $("#NavDrawerCustom .mobile-nav--expanded").removeClass(
                "mobile-nav--expanded",
              );
            }
            $(this).addClass("mobile-nav--expanded");
          }
        });
      });
    }
  }

  function SetupSearchToggle() {
    $(".menu__item.menu__item--icons .search-popdown__toggle").click(
      function () {
        $(".logo").hide();
        CloseOpenedNavMenu();
        var inputField = document.querySelector("#searchInput-desktop");
        inputField.value = "";
        inputField.dispatchEvent(new Event("input"));
        console.log("SetupSearchToggle trigger");
        setTimeout(function () {
          $("#searchInput-desktop")[0].focus();
        }, 100);
      },
    );

    $(".customNavDrawer .search-popdown__toggle").click(function () {
      let $inputSearch = $(this).next().find("#searchInput-desktop-compress");
      $inputSearch.val("");
      setTimeout(function () {
        console.log("ok Let's open the search bar and focus it !");
        console.log($inputSearch);
        $inputSearch[0].focus();
      }, 100);
    });
    $(".customNavDrawer .mobile-search-label").click(function () {
      let summary = $(this).prev().find("summary");
      summary.trigger("click");
    });

    $(".search-popdown__close").click(function () {
      $(".logo").show();
    });
    $(document).on("click", ".search-opened .main-content", function () {
      $(".logo").show();
    });
    $(document).keyup(function (e) {
      if (e.key === "Escape") {
        // escape key maps to keycode `27`
        if ($(".search-opened").length) {
          $(".logo").show();
        }
      }
    });
  }

  function SetupVariantSelector() {
    //Global behaviour for custom product variant selector
    if (
      $(".product-single__details .custom-selector-container").length ||
      $(".btn--quick").length
    ) {
      //Open one custom selector list at time
      $(document).on("click", ".custom-selector-container", function () {
        var $this = $(this).children().first();
        $(".custom-selector-inner.open").each(function () {
          //On compare les éléments HTML -> Si on utilise directement les objets JS, les contextes sont différents et ne sont donc pas égaux.
          if ($(this)[0] != $this[0]) {
            $(this).removeClass("open");
          }
        });
        this.querySelector(".custom-selector-inner").classList.toggle("open");
      });

      //Close custom selector list if user click anywhere on page
      window.addEventListener("click", function (e) {
        if ($(".custom-selector-container.open").length) {
          const select = document.querySelector(
            ".custom-selector-container.open",
          );
          if (!select.contains(e.target)) {
            select.classList.remove("open");
          }
        }
      });
    }

    //Product behaviour
    if ($(".product-single__details .custom-selector-container").length) {
      //Confirm option choiced in custom selector list
      for (const option of document.querySelectorAll(
        ".product-single__details .custom-selector__option",
      )) {
        option.addEventListener("click", function () {
          //Size process
          if ($(this).closest(".related-size-form").length) {
            let sizeRadioInput = $(this)
              .closest(".custom-size-selector")
              .next()
              .find(".radio__input");
            sizeRadioInput.each(function () {
              $(this).removeAttr("checked");
            });

            let optionValue = $(this).data("value");
            let optionMatch = $(this)
              .closest(".custom-size-selector")
              .next()
              .find('.radio__input[value="' + optionValue + '"]');
            optionMatch
              .attr("checked", true)
              .trigger("click")
              .trigger("change");
            $(this).closest("form.product__form").trigger("change");

            //Out of stock process
            let isOOS = $(this).hasClass("sold-out") ? true : false;
            if (isOOS) {
              let newText = optionValue + " Notify Me When Re-Stocked";
              $(".product__submit__item button")
                .text("Unavailable")
                .prop("disabled", "disabled");
            } else {
              $(".product__submit__item button")
                .text("Add to Cart")
                .removeProp("disabled");
            }
          }

          //Amount process (for gift cards)
          if ($(this).closest(".related-amount-form").length) {
            let amountRadioInput = $(this)
              .closest(".custom-amount-selector")
              .next()
              .find(".radio__input");
            amountRadioInput.each(function () {
              $(this).removeAttr("checked");
            });

            let optionValue = $(this).data("value");
            let optionMatch = $(this)
              .closest(".custom-amount-selector")
              .next()
              .find('.radio__input[value="' + optionValue + '"]');
            optionMatch
              .attr("checked", true)
              .trigger("click")
              .trigger("change");
            $(this).closest("form.product__form").trigger("change");
          }

          if (!this.classList.contains("selected")) {
            if (
              $(this).parent().find(".custom-selector__option.selected").length
            ) {
              this.parentNode
                .querySelector(".custom-selector__option.selected")
                .classList.remove("selected");
            }
            this.classList.add("selected");
          }
          let newText = $(this).text();
          $(this)
            .closest(".custom-selector-container")
            .find(".custom-selector__selected-value")
            .text(newText);

          //Color process
          if ($(this).closest(".related-color-form").length) {
            let currentLocale = ExtractLocaleInString(window.location.href);
            let testedLocal = ExtractLocaleInString($(this).data("url"));
            let url = $(this).data("url");
            if (
              currentLocale &&
              $(this).data("url") &&
              $(this).data("url") != "#" &&
              currentLocale != testedLocal
            ) {
              if (testedLocal) {
                let strToReplace = "baserange.com/" + testedLocal;
                url = $(this)
                  .data("url")
                  .replace(strToReplace, "baserange.com/" + currentLocale);
              } else {
                url = "/" + currentLocale + url;
              }
            }
            window.location.href = url;
          }
        });
      }
    }

    //Quick-buy behaviour (slightly different)
    if (
      $(".btn--quick").length ||
      $(".product-single__details .custom-selector-container").length
    ) {
      //Confirm option choiced in custom selector list
      $(document).on(
        "click",
        ".popup-quick-view__body .custom-selector__option",
        function () {
          //Size process
          if ($(this).closest(".related-size-form").length) {
            let sizeRadioInput = $(this)
              .closest(".custom-size-selector")
              .next()
              .find(".radio__input");
            sizeRadioInput.each(function () {
              $(this).removeAttr("checked");
            });

            let optionValue = $(this).data("value");
            let optionMatch = $(this)
              .closest(".custom-size-selector")
              .next()
              .find('.radio__input[value="' + optionValue + '"]');
            optionMatch
              .attr("checked", true)
              .trigger("click")
              .trigger("change");
            $(this).closest("form.product__form").trigger("change");

            //Out of stock process
            let isOOS = $(this).hasClass("sold-out") ? true : false;
            if (isOOS) {
              let newText = optionValue + " Notify Me When Re-Stocked";
              $(".product__submit__item button")
                .text("Unavailable")
                .prop("disabled", "disabled");
            } else {
              $(".product__submit__item button")
                .text("Add to Cart")
                .removeProp("disabled");
            }
          }

          //Amount process (for gift cards)
          if ($(this).closest(".related-amount-form").length) {
            let amountRadioInput = $(this)
              .closest(".custom-amount-selector")
              .next()
              .find(".radio__input");
            amountRadioInput.each(function () {
              $(this).removeAttr("checked");
            });

            let optionValue = $(this).data("value");
            let optionMatch = $(this)
              .closest(".custom-amount-selector")
              .next()
              .find('.radio__input[value="' + optionValue + '"]');
            optionMatch
              .attr("checked", true)
              .trigger("click")
              .trigger("change");
            $(this).closest("form.product__form").trigger("change");

            //Out of stock process
            let isOOS = $(this).hasClass("sold-out") ? true : false;
            if (isOOS) {
              let newText = optionValue + " Notify Me When Re-Stocked";
              $(".product__submit__item button")
                .text("Unavailable")
                .prop("disabled", "disabled");
            } else {
              $(".product__submit__item button")
                .text("Add to Cart")
                .removeProp("disabled");
            }
          }

          if (!$(this).hasClass("selected")) {
            if (
              $(this).parent().find(".custom-selector__option.selected").length
            ) {
              $(this)
                .parent()
                .find(".custom-selector__option.selected")
                .removeClass("selected");
            }
            $(this).addClass("selected");
          }
          let newText = $(this).text();
          $(this)
            .closest(".custom-selector-container")
            .find(".custom-selector__selected-value")
            .text(newText);

          //Color process
          if ($(this).closest(".related-color-form").length) {
            let currentLocale = ExtractLocaleInString(window.location.href);
            let testedLocal = ExtractLocaleInString($(this).data("url"));
            let url = $(this).data("url");

            if (
              currentLocale &&
              $(this).data("url") &&
              $(this).data("url") != "#" &&
              currentLocale != testedLocal
            ) {
              if (testedLocal) {
                let strToReplace = "baserange.com/" + testedLocal;
                url = $(this)
                  .data("url")
                  .replace(strToReplace, "baserange.com/" + currentLocale);
              } else {
                url = "/" + currentLocale + url;
              }
            }

            window.location.href = url;
          }
        },
      );

      //Fix the img height difference between featured media and slider img induced by theme
      // $('.product-grid-item').hover(function(){
      //   if($(this).hasClass("imgFixed")) { return true; } //Add a marker to skip the process (only do it once)
      //   let $featuredImg = $(this).find(".product-single__media-slide img"),
      //       $featuredImgHeight = $featuredImg.outerHeight(),
      //       $sliderImgs = $(this).find('.product__media__slide img'),
      //       $productImgGap = $sliderImgs.outerHeight() - $featuredImgHeight;

      //   console.log($featuredImgHeight);
      //   console.log($sliderImgs.outerHeight());
      //   console.log($productImgGap);

      //   $sliderImgs.each(function(){
      //     $(this).css({
      //       "min-height" : 1,
      //       "height": $featuredImgHeight
      //     });
      //   });

      //   $(this).addClass("imgFixed");
      // });
    }
  }

  // BR_Custom Siblings Colors Card
  function SetupSiblingColorPreview() {
    const canHoverSiblingPreview = window.matchMedia(
      "(hover: hover) and (pointer: fine)",
    ).matches;

    if (!canHoverSiblingPreview) return;
    if (!document.querySelector("[data-sibling-color-trigger]")) return;

    const cardSelector = "[data-product-block]";
    const gridLinkSelector = "[data-grid-link]";
    const triggerSelector = "[data-sibling-color-trigger]";
    const siblingColorsSelector = ".product-grid-item__sibling-colors";
    const dynamicLayerSelector = "[data-sibling-preview-layer]";
    const staticPreviewSelector = "[data-sibling-preview]";

    const dynamicStates = new WeakMap();

    function isSwiperCard(card) {
      return Boolean(card.querySelector("[data-card-swiper]"));
    }

    function storeOriginalLinks($card) {
      $card.find(gridLinkSelector).each(function () {
        if (!this.hasAttribute("data-original-href")) {
          this.setAttribute("data-original-href", this.getAttribute("href"));
        }
      });
    }

    function setCardLinks($card, url) {
      if (!url) return;

      storeOriginalLinks($card);
      $card.find(gridLinkSelector).attr("href", url);
    }

    function resetCardLinks($card) {
      $card.find(gridLinkSelector).each(function () {
        const originalHref = this.getAttribute("data-original-href");

        if (originalHref) {
          this.setAttribute("href", originalHref);
        }
      });
    }

    function clearActiveSiblingThumb($card) {
      $card.find(triggerSelector).removeClass("is-active");
    }

    function setActiveSiblingThumb($card, trigger) {
      clearActiveSiblingThumb($card);
      $(trigger).addClass("is-active");
    }

    /*
     * Dynamic preview
     * Used by hover secondary.
     * Swiper cards are handled by br-product-card-media.js.
     */
    function getDynamicState(card) {
      let state = dynamicStates.get(card);

      if (state) return state;

      const previewLayer = card.querySelector(dynamicLayerSelector);

      if (!previewLayer) return null;

      let previewImg = previewLayer.querySelector("img");

      if (!previewImg) {
        previewImg = document.createElement("img");
        previewImg.alt = "";
        previewImg.loading = "eager";
        previewImg.decoding = "async";
        previewImg.draggable = false;
        previewLayer.appendChild(previewImg);
      }

      state = {
        previewLayer,
        previewImg,
        preloadedImages: {},
        activeRequest: 0,
        hasPreloadedCardSiblings: false,
        hideTimer: null,
      };

      dynamicStates.set(card, state);

      return state;
    }

    function getPreviewSrc(trigger) {
      return trigger.getAttribute("data-sibling-preview-src") || "";
    }

    function preloadDynamicPreview(trigger, state, priority) {
      const src = getPreviewSrc(trigger);
      const srcset = trigger.getAttribute("data-sibling-preview-srcset");

      if (!src) return null;

      if (state.preloadedImages[src]) {
        const cachedImage = state.preloadedImages[src];

        if ("fetchPriority" in cachedImage && priority === "high") {
          cachedImage.fetchPriority = "high";
        }

        return cachedImage;
      }

      const image = new Image();

      image.alt = "";
      image.decoding = "async";

      if ("fetchPriority" in image) {
        image.fetchPriority = priority || "low";
      }

      if (srcset) {
        image.sizes = "(min-width: 768px) 25vw, 50vw";
        image.srcset = srcset;
      }

      image.src = src;

      state.preloadedImages[src] = image;

      return image;
    }

    function preloadDynamicCardSiblings(card, state) {
      if (state.hasPreloadedCardSiblings) return;

      state.hasPreloadedCardSiblings = true;

      card.querySelectorAll(triggerSelector).forEach(function (trigger) {
        preloadDynamicPreview(trigger, state, "low");
      });
    }

    function applyDynamicPreview(trigger, state, image) {
      const src =
        image && image.currentSrc ? image.currentSrc : getPreviewSrc(trigger);

      if (!src) return;

      /*
       * We reuse the exact URL selected by the preload image.
       * This avoids asking the browser to select another srcset candidate.
       */
      state.previewImg.removeAttribute("srcset");
      state.previewImg.removeAttribute("sizes");

      if (state.previewImg.getAttribute("src") !== src) {
        state.previewImg.setAttribute("src", src);
      }

      state.previewLayer.classList.add("is-active");
    }

    function swapMaterialAndPrice($card, trigger) {
      var material = trigger.getAttribute("data-sibling-material") || "";
      var priceTemplate = trigger.querySelector(
        "template[data-sibling-price-template]",
      );

      var materialEl = $card.find("[data-product-material]")[0];
      var priceEl = $card.find("[data-product-price]")[0];

      if (materialEl) {
        if (materialEl.dataset.originalHtml === undefined) {
          materialEl.dataset.originalHtml = materialEl.innerHTML;
          materialEl.dataset.originalHidden = materialEl.hasAttribute("hidden")
            ? "true"
            : "false";
        }
        if (material) {
          materialEl.textContent = material;
          materialEl.removeAttribute("hidden");
        } else {
          materialEl.setAttribute("hidden", "");
        }
      }

      if (priceEl && priceTemplate) {
        if (priceEl.dataset.originalHtml === undefined) {
          priceEl.dataset.originalHtml = priceEl.innerHTML;
        }
        priceEl.innerHTML = priceTemplate.innerHTML;
      }
    }

    function resetMaterialAndPrice($card) {
      var materialEl = $card.find("[data-product-material]")[0];
      var priceEl = $card.find("[data-product-price]")[0];

      if (materialEl && materialEl.dataset.originalHtml !== undefined) {
        materialEl.innerHTML = materialEl.dataset.originalHtml;
        if (materialEl.dataset.originalHidden === "true") {
          materialEl.setAttribute("hidden", "");
        } else {
          materialEl.removeAttribute("hidden");
        }
      }

      if (priceEl && priceEl.dataset.originalHtml !== undefined) {
        priceEl.innerHTML = priceEl.dataset.originalHtml;
      }
    }

    function showDynamicPreview($card, trigger) {
      const card = $card[0];
      const state = getDynamicState(card);
      const src = getPreviewSrc(trigger);
      const url = trigger.getAttribute("data-sibling-url");

      if (!state || !src) return;

      window.clearTimeout(state.hideTimer);

      state.activeRequest += 1;

      const requestId = state.activeRequest;
      const image = preloadDynamicPreview(trigger, state, "high");

      $card.addClass("is-sibling-previewing");
      setActiveSiblingThumb($card, trigger);
      setCardLinks($card, url);
      swapMaterialAndPrice($card, trigger);

      /*
       * Keep the previous sibling visible while moving rapidly
       * between color swatches.
       */
      if (state.previewImg.getAttribute("src")) {
        state.previewLayer.classList.add("is-active");
      }

      if (!image) return;

      function applyWhenReady() {
        if (requestId !== state.activeRequest) return;

        if (image.decode) {
          image
            .decode()
            .then(function () {
              if (requestId !== state.activeRequest) return;

              applyDynamicPreview(trigger, state, image);
            })
            .catch(function () {
              if (requestId !== state.activeRequest) return;

              applyDynamicPreview(trigger, state, image);
            });
        } else {
          applyDynamicPreview(trigger, state, image);
        }
      }

      if (image.complete && image.naturalWidth > 0) {
        applyWhenReady();
        return;
      }

      image.onload = applyWhenReady;
      image.onerror = function () {};
    }

    function hideDynamicPreview($card, withDelay) {
      const card = $card[0];
      const state = getDynamicState(card);

      if (!state) return;

      window.clearTimeout(state.hideTimer);

      function hide() {
        state.activeRequest += 1;
        state.previewLayer.classList.remove("is-active");
        $card.removeClass("is-sibling-previewing");
        clearActiveSiblingThumb($card);
        resetCardLinks($card);
        resetMaterialAndPrice($card);
      }

      if (withDelay) {
        state.hideTimer = window.setTimeout(hide, 140);
      } else {
        hide();
      }
    }

    /*
     * Static fallback
     * Used only when the Liquid renders [data-sibling-preview].
     */
    function preloadStaticSiblingPreviews($card) {
      $card.find(staticPreviewSelector + " img").each(function () {
        if (this.dataset.brPreviewLoaded === "true") return;

        this.dataset.brPreviewLoaded = "true";
        this.loading = "eager";

        if (this.decode) {
          this.decode().catch(function () {});
        }
      });
    }

    function showStaticPreview($card, trigger) {
      const previewId = trigger.getAttribute("data-sibling-preview-id");
      const url = trigger.getAttribute("data-sibling-url");

      if (!previewId) return;

      $card.addClass("is-sibling-previewing");
      $card.find(staticPreviewSelector).removeClass("is-active");
      $card
        .find('[data-sibling-preview="' + previewId + '"]')
        .addClass("is-active");

      setActiveSiblingThumb($card, trigger);
      setCardLinks($card, url);
      swapMaterialAndPrice($card, trigger);
    }

    function hideStaticPreview($card) {
      $card.removeClass("is-sibling-previewing");
      $card.find(staticPreviewSelector).removeClass("is-active");
      clearActiveSiblingThumb($card);
      resetCardLinks($card);
      resetMaterialAndPrice($card);
    }

    /*
     * Avoid duplicate delegated handlers if the setup function
     * is called again after a Shopify section reload.
     */
    $(document).off(".brSiblingPreview");

    $(document).on("mouseenter.brSiblingPreview", cardSelector, function () {
      const card = this;

      /*
       * Swiper sibling previews remain handled by
       * br-product-card-media.js.
       */
      if (isSwiperCard(card)) return;

      const state = getDynamicState(card);

      if (state) {
        preloadDynamicCardSiblings(card, state);
        return;
      }

      preloadStaticSiblingPreviews($(card));
    });

    $(document).on(
      "mouseenter.brSiblingPreview focusin.brSiblingPreview",
      triggerSelector,
      function () {
        const $card = $(this).closest(cardSelector);
        const card = $card[0];

        if (!card || isSwiperCard(card)) return;

        if (card.querySelector(dynamicLayerSelector)) {
          showDynamicPreview($card, this);
        } else {
          showStaticPreview($card, this);
        }
      },
    );

    $(document).on(
      "mouseenter.brSiblingPreview",
      siblingColorsSelector,
      function () {
        const $card = $(this).closest(cardSelector);
        const card = $card[0];

        if (!card || isSwiperCard(card)) return;

        const state = getDynamicState(card);

        if (state) {
          window.clearTimeout(state.hideTimer);
        }
      },
    );

    $(document).on(
      "mouseleave.brSiblingPreview",
      siblingColorsSelector,
      function () {
        const $card = $(this).closest(cardSelector);
        const card = $card[0];

        if (!card || isSwiperCard(card)) return;

        if (card.querySelector(dynamicLayerSelector)) {
          hideDynamicPreview($card, true);
        }
      },
    );

    $(document).on(
      "focusout.brSiblingPreview",
      siblingColorsSelector,
      function (event) {
        if (event.relatedTarget && this.contains(event.relatedTarget)) {
          return;
        }

        const $card = $(this).closest(cardSelector);
        const card = $card[0];

        if (!card || isSwiperCard(card)) return;

        if (card.querySelector(dynamicLayerSelector)) {
          hideDynamicPreview($card, true);
        }
      },
    );

    $(document).on("mouseleave.brSiblingPreview", cardSelector, function () {
      const card = this;
      const $card = $(card);

      if (isSwiperCard(card)) return;

      if (card.querySelector(dynamicLayerSelector)) {
        hideDynamicPreview($card, false);
      } else {
        hideStaticPreview($card);
      }
    });
  }

  // BR_Custom Moving Media
  function SetupMovingMedia() {
    const movingWrappers = document.querySelectorAll(
      ".moving, .collection-landing-veja section:first-child .br-media-highlight__media",
    );

    if (!movingWrappers.length) return;

    let ticking = false;

    function updateMovingImages() {
      const viewportHeight = window.innerHeight;

      movingWrappers.forEach(function (wrapper) {
        const img = wrapper.querySelector("img");
        if (!img) return;

        const rect = wrapper.getBoundingClientRect();

        if (rect.bottom < 0 || rect.top > viewportHeight) return;

        const start = viewportHeight;
        const end = -rect.height;
        const progress = (rect.top - end) / (start - end);
        const clamped = Math.max(0, Math.min(1, progress));
        const offset = (clamped - 0.5) * 40;

        img.style.setProperty("--moving-offset", offset + "px");
      });

      ticking = false;
    }

    function onScroll() {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(updateMovingImages);
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    updateMovingImages();
  }
  // End BR_Custom Moving Media

  function HandleQuickBuyOnTouch() {
    $(document).on("touchstart", ".product-grid-item", function (e) {
      if (!$(this).hasClass("quick-buy-mobile-init")) {
        $(".quick-buy-mobile-init").removeClass("quick-buy-mobile-init");
        $(this).addClass("quick-buy-mobile-init");
      }
    });
  }

  function SetupCartItemNumberTracking() {
    var $cartItemNumber = $(".cart_item_tracking");

    //Adjust Qty based on the AddToCart btn and the Quick Buy
    $(document).on("click", ".product__submit__add", function () {
      let currentCartItemNumber = parseInt($cartItemNumber.text()) + 1;
      $cartItemNumber.text(currentCartItemNumber);
    });
    //Adjust Qty based on +/- button in the ajax cart
    $(document).on("click", ".cart__item__quantity", function (e) {
      e.preventDefault();
      let currentCartItemNumber = parseInt($cartItemNumber.text());
      let $target = $(e.target);
      if (
        $target.hasClass("cart__item__quantity-minus") ||
        $target.hasClass("icon-toggle-minus")
      ) {
        currentCartItemNumber = currentCartItemNumber - 1;
      }
      if (
        $target.hasClass("cart__item__quantity-plus") ||
        $target.hasClass("icon-toggle-plus")
      ) {
        currentCartItemNumber = currentCartItemNumber + 1;
      }
      $cartItemNumber.text(currentCartItemNumber);
    });
    //Adjust Qty based on the Remove button in the ajax cart
    $(document).on("click", ".cart__item__remove", function () {
      let currentItemQty = $(this)
        .parent()
        .parent()
        .find(".cart__item__quantity-field")
        .val();
      let currentCartItemNumber =
        parseInt($cartItemNumber.text()) - currentItemQty;
      $cartItemNumber.text(currentCartItemNumber);
      console.log(currentItemQty);
    });
  }

  // BR_Custom Gift Wrap Item
  function SetupGiftWrapItems() {
    var inputSelector = "[data-gift-wrap-input]";
    var optionSelector = "[data-gift-wrap-option]";

    function cartUrl(endpoint) {
      var root =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "/";

      return root + endpoint.replace(/^\//, "");
    }

    function postCart(endpoint, payload) {
      return fetch(cartUrl(endpoint), {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }).then(function (response) {
        return response.text().then(function (text) {
          var data = {};

          try {
            data = text ? JSON.parse(text) : {};
          } catch (error) {
            data = { raw: text };
          }

          if (!response.ok) {
            console.warn("[BR Gift Wrap Item]", response.status, data);
            throw new Error("[BR Gift Wrap Item] Cart request failed");
          }

          return data;
        });
      });
    }

    function readBaseProperties($option) {
      var properties = {};

      $option.find("[data-gift-wrap-property-key]").each(function () {
        var key = this.getAttribute("data-gift-wrap-property-key");
        var value = this.getAttribute("data-gift-wrap-property-value");

        if (key && value) {
          properties[key] = value;
        }
      });

      return properties;
    }

    function setOptionState($option, checked, isLoading) {
      $option.find(inputSelector).prop("checked", checked);
      $option.find(inputSelector).prop("disabled", !!isLoading);
      $option.toggleClass("is-checked", checked);
      $option.toggleClass("is-updating", !!isLoading);
    }

    function updateStoredLineKey($option, cart) {
      var line = parseInt($option.attr("data-line"), 10);
      var item = cart && cart.items ? cart.items[line - 1] : null;

      if (!item || !item.key) return;

      $(optionSelector + '[data-line="' + line + '"]').attr(
        "data-line-key",
        item.key,
      );
    }

    function updateGiftWrap($option, checked) {
      var lineKey = $option.attr("data-line-key");
      var properties = readBaseProperties($option);

      if (!lineKey) {
        throw new Error("[BR Gift Wrap Item] Missing line item key");
      }

      if (checked) {
        properties["Gift wrap"] = "yes";
      } else if (!Object.keys(properties).length) {
        properties["Gift wrap"] = "";
      }

      return postCart("cart/change.js", {
        id: String(lineKey),
        properties: properties,
      }).then(function (cart) {
        updateStoredLineKey($option, cart);

        console.log("[BR Gift Wrap Item] Updated", {
          checked: checked,
          lineKey: $option.attr("data-line-key"),
          properties: properties,
          cart: cart,
        });

        return cart;
      });
    }

    $(document).on("change", inputSelector, function () {
      var input = this;
      var $option = $(input).closest(optionSelector);
      var checked = input.checked;
      var previousChecked = !checked;

      setOptionState($option, checked, true);

      updateGiftWrap($option, checked)
        .then(function () {
          setOptionState($option, checked, false);
        })
        .catch(function (error) {
          console.warn("[BR Gift Wrap Item]", error);
          setOptionState($option, previousChecked, false);
        });
    });
  }
  // End BR_Custom Gift Wrap Item

  function SetupBlogMenu() {
    let widthElement = $(".pgi.grid__item").first().width();
    $(".category-filter-menu li").width(widthElement);
    $(window).on("resize", function () {
      let newWidthElement = $(".pgi.grid__item").first().width();
      $(".category-filter-menu li").width(newWidthElement);
    });

    $(document).on(
      "click",
      ".blog-menu-control .show-more-blog-menu-link, .blog-menu-control .show-less-blog-menu-link",
      function (e) {
        e.preventDefault();
        ProcessBlogMenu("desktop");
      },
    );
    $(document).on(
      "click",
      ".blog-menu-control-mobile .show-more-blog-menu-link, .blog-menu-control-mobile .show-less-blog-menu-link",
      function (e) {
        e.preventDefault();
        ProcessBlogMenu("mobile");
      },
    );
  }

  // Page Blog
  function ProcessBlogMenu(mode) {
    $(".show-more-blog-menu-link").toggle();
    $(".show-less-blog-menu-link").toggle();
    if (mode == "desktop") {
      var nbLi = $("ul.category-filter-menu:nth-child(2) li").length;
      var nbTodisplay = Math.ceil((nbLi - 9) / 3);
      var newHeight = nbTodisplay * 26;
      $("ul.category-filter-menu:nth-child(2)").css(
        "max-height",
        newHeight + "px",
      );
      $("ul.category-filter-menu:nth-child(2)").toggleClass(
        "category-filter-menu-open",
      );
      $("header.section-header").toggleClass("blog-menu-open");
    } else {
      $("ul.category-filter-menu:nth-child(1) li:nth-child(n+7)").toggle();
    }
  }

  //Page Contact
  function SetupContactForm() {
    $(".shogun-form-dropdown select").change(function () {
      if (
        $(this).val() == "Returns & Exchanges" ||
        $(this).val() == "Order Payment" ||
        $(this).val() == "Shipping tracking"
      ) {
        if (!$(".contact-form-order-number").length) {
          var orderNumberField =
            '<div id="s-403a2bda-86ac-4511-9dd7-cb4d20323cc4" class="shg-c contact-form-order-number">';
          orderNumberField +=
            '<div class="shogun-form-text-input" data-field-type="text">';
          orderNumberField +=
            '<label class="shogun-form-label">Country</label>';
          orderNumberField +=
            '<input id="input-s-403a2bda-86ac-4511-9dd7-cb4d20323cc4" class="shogun-form-box-field shogun-form-text-input-field" name="Order_Number" placeholder="Order Number" type="text" required="true">';
          orderNumberField +=
            '<div class="shogun-form-field-error-msg-container">';
          orderNumberField += '<div class="shogun-form-field-error-msg">';
          orderNumberField +=
            '<svg viewBox="0 0 26 26" width="16px" height="16px">';
          orderNumberField +=
            '<path d="M13 1c6.627 0 12 5.373 12 12s-5.373 12-12 12S1 19.627 1 13 6.373 1 13 1zm0 1.5C7.201 2.5 2.5 7.201 2.5 13S7.201 23.5 13 23.5 23.5 18.799 23.5 13 18.799 2.5 13 2.5zm0 14.25l.123.007a1.125 1.125 0 11-.246 0L13 16.75zM13 5.5a.75.75 0 01.743.648l.007.102v8.25a.75.75 0 01-1.493.102l-.007-.102V6.25A.75.75 0 0113 5.5z" fill="currentColor" fillrule="nonzero"></path>';
          orderNumberField += "</svg>";
          orderNumberField += "<span>Value is required</span>";
          orderNumberField += "</div>";
          orderNumberField += "</div>";
          orderNumberField += "</div>";
          orderNumberField += "</div>";

          $(orderNumberField).insertAfter($(this).parent().parent());
        }
      } else {
        if ($(".contact-form-order-number").length) {
          $(".contact-form-order-number").remove();
        }
      }
    });
  }

  //Page Production
  function RedirectToCorrepondingMobilePage() {
    let pageUrl = window.location.href;
    if (pageUrl[pageUrl.length - 1] == "/") {
      pageUrl = pageUrl.substr(pageUrl.length - 1);
    }
    let isMobile = navigator.userAgent.match(
      /(iPhone|iPo@d|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i,
    );
    if (isMobile && pageUrl.indexOf("productionmobile") == -1) {
      window.location.replace(pageUrl + "mobile");
    }
  }
  function SetupProductionPageElements() {
    var $menuElements = [];
    $(".page-production-menu").each(function (ul) {
      $(this)
        .children()
        .each(function (li) {
          $menuElements.push($(this));
        });
    });

    $(window).scroll(function () {
      $.each($menuElements, function (i, $li) {
        let $link = $($li[0]).find("a");
        let idToUse = $link.attr("href").split("#").pop();
        let $el = $("#" + idToUse);
        if ($el.isInViewport()) {
          if (!$link.hasClass("page-menu-active")) {
            $(".page-menu-active").removeClass("page-menu-active");
            $link.addClass("page-menu-active");
          }
        }
      });
    });
  }

  //Third Party
  function SetupShogunTrigger() {
    $(document).on("submit", "form.search-bar", function () {
      gtag("event", "recherche", {
        event_category: "engagement",
        event_label: "",
      });
    });
    $(document).on("submit", "form.klaviyo-form-version-cid_1", function () {
      gtag("event", "inscription_newsletter", {
        event_category: "prospect",
        event_label: "footer",
      });
    });
    $(document).on("submit", "form.klaviyo-form-version-cid_3", function () {
      gtag("event", "inscription_newsletter", {
        event_category: "prospect",
        event_label: "popup",
      });
    });
    $(document).on("submit", "form.shogun-form-box", function () {
      gtag("event", "envoi_formulaire_contact", {
        event_category: "prospect",
        event_label: "",
      });
    });
    $(document).on("click", ".klaviyo-close-form", function () {
      gtag("event", "fermeture_newsletter", {
        event_category: "engagement",
        event_label: "pop_up",
      });
    });
    $(document).on("click", "#Tokyo", function () {
      gtag("event", "clic_instagram", {
        event_category: "engagement",
        event_label: "Tokyo",
      });
    });
    $(document).on("click", "#Kyoto", function () {
      gtag("event", "clic_instagram", {
        event_category: "engagement",
        event_label: "Kyoto",
      });
    });
    $(document).on("click", "#Seoul", function () {
      gtag("event", "clic_instagram", {
        event_category: "engagement",
        event_label: "Seoul",
      });
    });
    $(document).on("click", "#Melbourne", function () {
      gtag("event", "clic_instagram", {
        event_category: "engagement",
        event_label: "Melbourne",
      });
    });
    $(document).on(
      "click",
      "#baserange-stockists .shogun-root a",
      function (e) {
        var txt = $(e.target).text();
        gtag("event", "clic_lien_sortant", {
          event_category: "prospect",
          event_label: txt,
        });
      },
    );
  }

  /**
   * Get the current Local in a string
   * @param {String} - The string to parse
   * @Return {String} - locale code if it found, else return false
   */
  function ExtractLocaleInString(str) {
    var result = false;
    var locales = [
      "en",
      "fr",
      "de",
      "ja",
      "ko",
      "zh",
      "en-us",
      "fr-us",
      "de-us",
      "ja-us",
      "ko-us",
      "zh-us",
      "en-jp",
      "fr-jp",
      "de-jp",
      "ja-jp",
      "ko-jp",
      "zh-jp",
      "en-kr",
      "fr-kr",
      "de-kr",
      "ja-kr",
      "ko-kr",
      "zh-kr",
      "en-cn",
      "fr-cn",
      "de-cn",
      "ja-cn",
      "ko-cn",
      "zh-cn",
    ];
    for (var i = 0; i < locales.length; i++) {
      let pattern1 = new RegExp("/" + locales[i] + "$");
      let pattern2 = new RegExp("/" + locales[i] + "/");
      if (str.match(pattern1) || str.match(pattern2)) {
        result = locales[i];
        break;
      }
    }
    return result;
  }

  /**
   * Check if the target element is int the viewport of the navigator
   * @return {Bool} - True if taget is in viewport, else False
   */
  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  // BR_Custom: sur touch, le premier tap doit ouvrir la fiche produit directement,
  // sans attendre le double-tap exigé par WebKit. On distingue bien un vrai tap
  // (doigt posé et relâché sans bouger) d'un scroll (doigt qui glisse).
  function SetupDirectTapNavigation() {
    var canHover = window.matchMedia(
      "(hover: hover) and (pointer: fine)",
    ).matches;
    if (canHover) return; // ne s'applique qu'aux devices tactiles

    var startX = 0;
    var startY = 0;
    var startTime = 0;
    var moveThreshold = 10; // px de tolérance avant de considérer que c'est un scroll
    var timeThreshold = 500; // ms max pour que ce soit un "tap" et non un appui long

    document.addEventListener(
      "touchstart",
      function (event) {
        var link = event.target.closest("[data-grid-link]");
        if (!link) return;
        if (link.closest("[data-card-swiper]")) return;

        var touch = event.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        startTime = Date.now();
      },
      { passive: true },
    );

    document.addEventListener(
      "touchend",
      function (event) {
        var link = event.target.closest("[data-grid-link]");
        if (!link) return;
        if (link.closest("[data-card-swiper]")) return;

        var touch = event.changedTouches[0];
        var deltaX = Math.abs(touch.clientX - startX);
        var deltaY = Math.abs(touch.clientY - startY);
        var deltaTime = Date.now() - startTime;

        // Si le doigt a bougé (scroll/swipe) ou si l'appui a été trop long, on laisse faire le navigateur normalement
        if (
          deltaX > moveThreshold ||
          deltaY > moveThreshold ||
          deltaTime > timeThreshold
        ) {
          return;
        }

        event.preventDefault();
        window.location.href = link.href;
      },
      { passive: false },
    );
  }

  // BR_Custom: Top bar mobile dismissible avec persistance cookie
  function SetupTopBarMobileDismiss() {
    var showsTopBar = window.matchMedia(
      "(hover: none) and (pointer: coarse), (max-width: 1100px)",
    ).matches;
    if (!showsTopBar) return; // desktop large + souris: rien à faire, pas de mesure, pas de listener

    var COOKIE_NAME = "br_top_bar_dismissed";
    var COOKIE_DAYS = 15;
    var bar = document.querySelector("[data-top-bar-mobile]");
    var header = document.querySelector("#SiteHeader");

    function setHeaderHeightVar() {
      if (!header) return;
      var h = header.getBoundingClientRect().height;
      document.documentElement.style.setProperty(
        "--header-total-height",
        h + "px",
      );
    }

    function getCookie(name) {
      var match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)"),
      );
      return match ? match[2] : null;
    }
    function setCookie(name, value, days) {
      var expires = new Date();
      expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie =
        name + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
    }

    if (!bar) {
      setHeaderHeightVar();
      return;
    }

    if (getCookie(COOKIE_NAME) === "true") {
      bar.style.display = "none";
    }

    setHeaderHeightVar();

    var dismissButton = bar.querySelector("[data-top-bar-dismiss]");
    if (dismissButton) {
      dismissButton.addEventListener("click", function () {
        setCookie(COOKIE_NAME, "true", COOKIE_DAYS);
        bar.classList.add("is-dismissing");
        window.setTimeout(function () {
          bar.style.display = "none";
          setHeaderHeightVar();
        }, 250);
      });
    }
  }

  // Back To Top
  $(document).on("click", ".br_back_to_top", function (event) {
    event.preventDefault();
    var reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
  });
})();
